import { signal } from '@preact/signals-react';
import { fetchAiAssignments } from 'api/model/services/services-api';
import { TRANSLATION_ASSIGNMENT_NAME } from 'api/model/services/aitools';
export const aiAssignmentsSignal = signal({ status: 'idle' });
export const loadAiAssignments = async (connection) => {
    const result = await fetchAiAssignments(connection);
    if (result.isSuccess()) {
        aiAssignmentsSignal.value = {
            status: 'loaded',
            assignments: result.get().assignments,
        };
    }
    else {
        aiAssignmentsSignal.value = { status: 'error' };
    }
};
export const findTranslateAssignment = () => {
    const state = aiAssignmentsSignal.value;
    if (state.status !== 'loaded') {
        return undefined;
    }
    return state.assignments.find((a) => a.name === TRANSLATION_ASSIGNMENT_NAME);
};
